import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './notification.types';
import * as constants from './notification.constants';

export const storeNotification = generateStoreResourceAction<types.INotification>(constants.STORE_NOTIFICATION);
export const clearNotification = generateClearResourceAction(constants.CLEAR_NOTIFICATION);
